import { usePut } from '../../../sharedModules/hooks/useQuery';

interface UpdateParams {
  acctNo: string;
  location: string;
  statementEnabled: boolean;
}

interface UpdateResponse {
  acct_no: string;
  statement_enabled: boolean;
}

export function useUpdateStatementEnabled() {
  const mutation = usePut<UpdateResponse>();

  const updateStatementEnabled = ({ acctNo, location, statementEnabled }: UpdateParams) =>
    mutation.mutateAsync({
      url: `/collections/statements/${acctNo}/enabled?location=${encodeURIComponent(location)}`,
      data: { statement: { statement_enabled: statementEnabled } },
    });

  return {
    updateStatementEnabled,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
